import { API } from "@/main.js";

const state = {
  optionsLists: {},
  optionLists: {
    phase: [],
    splicing_colors: [],
    closureType: [],
    closureLogicalType: [],
    cableType: [],
    progressType: [
      { code: "E", libelle: "Existing" },
      { code: "C", libelle: "To Construct" }
    ],
    materialFamily: [],
    poleType: [],
    poleHeight: [],
    poleClass: [],
    materialType: [],
    cabinetType: [],
    logicalType: [],
    physicalType: [],
    projections: [],
    fieldCableTypeOptions: [],
    extraWpDsp: [],
  }
};

const getters = {
  getListOfOptionsByListName: state => (
    listName,
    code = [],
    includeDeleted = false
  ) => {
    let list = state.optionsLists[listName];
    if (list && list.custom) {
      return list;
    }
    return includeDeleted
      ? list
      : list
      ? state.optionsLists[listName].filter(
          option => !option.deleted || code.includes(option.code)
        )
      : null;
  },
  optionLists_phase: state => state.optionLists.phase,
  optionLists_splicingColors: state => state.optionLists.splicing_colors,
  optionLists_closureType: state => state.optionLists.closureType,
  optionLists_closureLogicalType: state => state.optionLists.closureLogicalType,
  optionLists_progressType: state => state.optionLists.progressType,
  optionLists_cableType: state => state.optionLists.cableType,
  optionLists_materialFamily: state => state.optionLists.materialFamily,
  optionLists_contractTypes: state => state.optionLists.contractTypes,
  optionLists_classificationTypes: state => state.optionLists.classificationTypes,
  optionLists_cableMaterials: state => state.optionLists.cableMaterials,
  optionLists_poleType: state => state.optionLists.poleType,
  optionLists_poleHeight: state => state.optionLists.poleHeight,
  optionLists_poleClass: state => state.optionLists.poleClass,
  optionLists_projections: state => state.optionLists.projections,
  optionLists_materialType: state => state.optionLists.materialType,
  optionLists_cabinetType: state => state.optionLists.cabinetType,
  optionLists_logicalType: state => state.optionLists.logicalType,
  optionLists_physicalType: state => state.optionLists.physicalType,
  optionLists_fieldCableTypeOptions: state =>
    state.optionLists.fieldCableTypeOptions,
    optionLists_extraWpDsp: state => state.optionLists.extraWpDsp,
  getAllObjectsOptionsLists: state => state.optionsLists
};

const mutations = {
  GET_ALL_LISTS(state, lists) {
    state.optionLists.splicing_colors = lists.list_fo_color;
    state.optionLists.phase = lists.list_statut;
    state.optionLists.closureType = lists.list_bp_type_phy;
    state.optionLists.closureLogicalType = lists.list_bp_type_log;
    state.optionLists.cableType = lists.list_infra_type_log;
    state.optionLists.materialFamily = lists.list_material_family;
    state.optionLists.poleType = lists.list_ptech_pole_type;
    state.optionLists.poleHeight = lists.list_ptech_height;
    state.optionLists.poleClass = lists.list_pole_class;
    state.optionLists.materialType = lists.list_ptech_nature;
    state.optionLists.cabinetType = lists.list_ptech_cabinet_type;
    state.optionLists.logicalType = lists.list_site_type_log;
    state.optionLists.physicalType = lists.list_site_type_phy;
    state.optionLists.projections = lists.list_projections;
    state.optionLists.extraWpDsp =  lists.list_extra_wp_dsp;
    state.optionLists.fieldCableTypeOptions =
      lists.list_field_cable_type_options;
    state.optionLists.contractTypes = lists.list_extra_bd_contract_status
    state.optionLists.classificationTypes = lists.list_bd_type_zone
    state.optionLists.cableMaterials = lists.list_cable_material
  },

  GET_ALL_LISTS_ORIGINAL(state, lists) {
    state.optionsLists = lists;
  },

  UPDATE_LIST(state, data) {
    state.optionsLists[data.listName] = data.listContent;
  },

  UPDATE_LIST_VALUE(state, data) {
    state.optionsLists[data.listName].push(data.listValueData);
  }
};

const actions = {
  GET_ALL_LISTS: ({ commit }) => {
    return new Promise((resolve, reject) => {
      API.lists.getAll(
        result => {
          commit("GET_ALL_LISTS_ORIGINAL", result.data.data);
          commit("GET_ALL_LISTS", result.data.data);
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_LIST_OF_LISTS: ({ commit }, queryParams = null) => {
    return new Promise((resolve, reject) => {
      API.lists.getListOfLists(
        queryParams,
        result => {
          commit("GET_ALL_LISTS_ORIGINAL", result.data.data);
          commit("GET_ALL_LISTS", result.data.data);
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_LIST: (
    { commit, state },
    { listName, code = [], includeDeleted = null }
  ) => {
    return new Promise((resolve, reject) => {
      API.lists.getByType(
        listName,
        undefined,
        result => {
          let list = result.data.data[listName];
          if (!!list && !Array.isArray(list)) {
            list = Object.values(list);
          }
          commit("UPDATE_LIST", { listName: listName, listContent: list });
          if (!!list && !includeDeleted) {
            list = list.filter(
              listItem => !listItem.deleted || code.includes(listItem.code)
            );
          }
          resolve(list);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_LIST_FILTERED: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.lists.getByType(
        data.listName,
        data.listFilters,
        result => {
          let list = result.data.data[data.listName];
          resolve(list);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  UPDATE_LIST: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      API.lists.editList(
        data.uuid,
        data.listValueData,
        result => {
          dispatch("GET_LIST_OF_LISTS");
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  DOWNLOAD_LIST: ({ commit }) => {
    return new Promise((resolve, reject) => {
      API.lists.downloadLists(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  CREATE_NEW_LIST_ITEM: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      API.lists.createListItem(
        data.listName,
        data.listValueData,
        result => {
          dispatch("GET_LIST", { listName: data.listName });
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  UPDATE_LIST_ITEM: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      API.lists.editListItem(
        data.listName,
        data.itemCode,
        data.listValueData,
        result => {
          dispatch("GET_LIST", { listName: data.listName });
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  DELETE_LIST_ITEM: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      API.lists.deleteListItem(
        data.listName,
        data.itemCode,
        result => {
          dispatch("GET_LIST", { listName: data.listName });
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  }


};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/lists.js